import React from "react";
import { motion } from "framer-motion";
import "./physiotherapy.css";

function Physiotherapy() {
  return (
    <div>
      <h2 className="physiotherapy-heading">Physiotherapy</h2>
      <motion.div
        className="container"
        initial={{ x: -100, opacity: 0 }} // Start from the left
        animate={{ x: 0, opacity: 1 }} // Move to original position
        transition={{ duration: 1, ease: "easeOut" }} // Smooth transition
      >
        <p className="physiotherapy-content">
          At Deepti, physiotherapy is provided for children with cerebral palsy
          by a dedicated team of qualified physiotherapists. Each child receives
          a personalized program focused on balance, strength, and coordination
          using games, equipment, and exercises to reduce spasticity and promote
          normal movement. Therapists guide families in supporting their child’s
          daily activities and recommend suitable equipment like splints or
          gaitors. Working closely with other professionals, they ensure
          holistic care and refer to external specialists when needed. Deepti’s
          modern physiotherapy center is well-equipped and also hosts training
          sessions led by experts in the field.{" "}
        </p>
      </motion.div>
    </div>
  );
}

export default Physiotherapy;
